(function () {
  if (window.__newsletterBotProtectionInit) return;
  window.__newsletterBotProtectionInit = true;

  const pageLoadTime = Date.now();
  const MIN_FILL_TIME_MS = 3000;

  document.addEventListener(
    'submit',
    function (e) {
      const form = e.target;
      if (!form || !form.classList || !form.classList.contains('newsletter-form')) return;

      const honeypot = form.querySelector('input[name="contact[website]"]');
      const elapsed = Date.now() - pageLoadTime;
      if ((honeypot && honeypot.value) || elapsed < MIN_FILL_TIME_MS) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );
})();
